import React, { useEffect, useState, useRef } from 'react';
import { Dimensions, Text, TouchableOpacity, View } from 'react-native';
import Header from '../../common/Header';
import * as RootNavigation from '../../utilities/RootNavigation';
import CImage from '../../common/CImage';
import CustomButton from '../../common/CustomButton';
import applicationStyles from '../../styles/applicationStyles';
import LoginFooter from './LoginFooter';
import LoginRightWidget from './LoginRightWidget';
import LoginTabIcons from './LoginTabIcons';
import LoginMoibleContent from './LoginMobileContent';
import useStyles from './SelectUnlockScreen_Styles';
import CView from '../../styles/CommonStyle';
import { COLORS } from '../../constant';
const isSmallDevice = Dimensions.get('window').width < 767;

export default function SelectUnlockScreen(props) {
  const styles = useStyles();
  const [value, setValue] = useState('1');

  const renderSelectUnlockScreen = () => {
    return (
      <View style={styles.containerBox}>
        <View style={styles.rectangle41}>
          <TouchableOpacity onPress={() => RootNavigation.navigate('Login')}>
            <CImage.BackIconWhite></CImage.BackIconWhite>
          </TouchableOpacity>
          <Text style={[applicationStyles.loginTextStyle]}>{'Activate/Unlock User ID'}</Text>
        </View>
        <View style={{ alignItems: 'center', marginTop: isSmallDevice ? 0 : '5%' }}>
          <Text style={styles.chooseOptionStyle}>{'Choose an option'}</Text>
          <CView AS JC MT={'15%'}>
            <View style={styles.selectionContainerStyle}>
              <TouchableOpacity
                onPress={() => setValue('1')}
                style={styles.radiobuttonOutSideStyle}>
                {value == '1' ? <View style={styles.radioButtonInsideStyle} /> : null}
              </TouchableOpacity>
              <Text style={styles.textStyle}>{'Activate User Id'}</Text>
            </View>
            <View style={[styles.selectionContainerStyle, { marginTop: 20 }]}>
              <TouchableOpacity
                onPress={() => setValue('2')}
                style={styles.radiobuttonOutSideStyle}>
                {value == '2' ? <View style={styles.radioButtonInsideStyle} /> : null}
              </TouchableOpacity>
              <Text style={styles.textStyle}>{'Unlock User Id'}</Text>
            </View>
          </CView>
        </View>
        <View style={styles.proceedBtn}>
          <CustomButton
            onPress={() => (value == '1' ? RootNavigation.navigate('ActivateUser') : RootNavigation.navigate('UnlockUserScreen'))}
            text={'Proceed'}
          />
        </View>
      </View>
    );
  };

  return (
    <CView
      W100
      HW>
      <View style={{ flex: 1 }}>
        <Header text={'Login'} />

        <View style={styles.bodyContainerStyle}>
          <CView
            BG={COLORS.grayOP69}
            flex={0.4}
            AC
            JC>
            {renderSelectUnlockScreen()}

            <LoginTabIcons />
          </CView>

          <LoginRightWidget />
        </View>
        <View style={styles.mobileComponentStyle}>
          <View style={styles.mobileContentWrapper}>
            <CView FR>
              <CImage.IDFCLogo></CImage.IDFCLogo>
            </CView>
            <View>
              <CImage.FFLogoSmall></CImage.FFLogoSmall>
            </View>
          </View>
          <View style={styles.mobileContentWidget}>{renderSelectUnlockScreen()}</View>
          <LoginMoibleContent />
        </View>
        <View style={styles.footerContainerStyle}>
        <LoginFooter />
        </View>
      </View>
    </CView>
  );
}
